import { Flex, Text } from "@daangn/carotene";
import { isNil } from "lodash";

import * as css from "./Empty.css";

type EmptyProps = {
  title?: string;
  subText?: string;
};
const Empty = ({ title, subText }: EmptyProps) => {
  return (
    <Flex
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
      width="full"
      gap={2.5}
      className={css.emptyWrapper}
    >
      {!isNil(title) && (
        <Text size="large" color="neutral" weight="strong">
          {title}
        </Text>
      )}
      {!isNil(subText) && (
        <Text size="medium" color="neutralSubtle">
          {subText}
        </Text>
      )}
    </Flex>
  );
};

export default Empty;
